import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, message, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { accountService } from '../../services/accountService';
import  categoryService  from '../../services/categoryService';
import { CloseOutlined } from '@ant-design/icons';

const { Option } = Select;

const AccountEditForm = ({ visible, account, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [divisionLoading, setDivisionLoading] = useState(false);

  useEffect(() => {
    if (visible && account) {
      loadDivisionOptions().then(() => {
        // 设置表单初始值
        form.setFieldsValue({
          loginId: account.loginId,
          name: account.name,
          email: account.email,
          mobile: account.mobile,
          division: account.orgCode // 根据orgCode设置division的初始值
        });
      });
    }
  }, [visible, account, form]);

  const loadDivisionOptions = async () => {
    try {
      setDivisionLoading(true);
      const response = await categoryService.listDivision();
      if (response.success) {
        setDivisionOptions(response.data);
      }
      return response;
    } catch (error) {
      console.error('获取事业部列表失败:', error);
      message.error(t('account.fetchDivisionFailed') || '获取事业部列表失败');
    } finally {
      setDivisionLoading(false);
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      
      // 构造API请求数据
      const accountData = {
        ...values,
        id: account.id,
        orgCode: values.division, // 将division值作为orgCode传递
        orgName: divisionOptions.find(option => option.value === values.division)?.label // 获取对应的label作为orgName
      };
      
      const response = await accountService.updateAccount(accountData);
      
      if (response.success) {
        message.success(t('account.updateSuccess'));
        onSuccess();
      } else {
        message.error(response.errorMessage || t('account.updateFailed'));
      }
    } catch (error) {
      console.error('更新账号失败:', error);
      message.error(t('account.updateFailed'));
    } finally {
      setLoading(false);
    }
  };

  const modalTitle = (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{t('account.editTitle')}</span>
      <CloseOutlined onClick={onCancel} style={{ cursor: 'pointer' }} />
    </div>
  );

  return (
    <Modal
      title={modalTitle}
      open={visible}
      onCancel={onCancel}
      destroyOnClose
      width={600}
      closable={false}
      className="account-edit-modal"
      footer={[
        <div key="footer" style={{ textAlign: 'right', padding: '10px 0' }}>
          <button 
            className="submit-button"
            onClick={handleSubmit}
            disabled={loading}
          >
            {t('common.submit')}
          </button>
        </div>
      ]}
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Form.Item
          name="loginId"
          label={t('account.account')}
        >
          <Input disabled />
        </Form.Item>

        <Form.Item
          name="name"
          label={t('account.name')}
          rules={[
            { required: true, message: t('account.nameRequired') },
            {
              pattern: /^[^!@#$%^&*()]+$/,
              message: t('account.nameSpecialCharNotAllowed') || '名字不能包含特殊字符 !@#$%^&*()'
            }
          ]}
        >
          <Input placeholder={t('common.pleaseInput')} />
        </Form.Item>

        <Form.Item
          name="division"
          label={<span className="required-label">{t('account.division')}</span>}
          rules={[{ required: true, message: t('account.divisionRequired') }]}
        >
          <Select 
            placeholder={t('account.divisionPlaceholder') || t('common.pleaseSelect')}
            loading={divisionLoading}
            allowClear
          >
            {divisionOptions.map(option => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="email"
          label={t('account.email')}
          rules={[
            { 
              type: 'email',
              message: t('account.emailInvalid')
            }
          ]}
        >
          <Input placeholder={t('common.pleaseInput')} />
        </Form.Item>

        {/* <Form.Item
          name="mobile"
          label={t('account.mobile')}
        >
          <Input placeholder={t('common.pleaseInput')} />
        </Form.Item> */}
      </Form>
    </Modal>
  );
};

export default AccountEditForm;